import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const STAGING_HOST = 'https://staging.wasombouw.nl';
const STAGING_TOKEN = btoa('wasombouw2025:webmixwasombouw!');

/**
 * Adds HTTP Basic Auth header to every request targeting the staging server,
 * EXCEPT for WP REST API paths (/wp-json/).
 *
 * staging.wasombouw.nl is protected with an htaccess password (<LimitExcept OPTIONS>).
 * This interceptor is a no-op for any other host.
 *
 * REST API calls (/wp-json/) are authenticated separately via consumer_key / consumer_secret
 * query parameters so that the WooCommerce authentication layer does not see an
 * htaccess Authorization header (which is not a valid WooCommerce consumer key and
 * would cause WooCommerce to reject the request with a 401 authentication error).
 */
@Injectable()
export class StagingAuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isStaging = req.url.startsWith(STAGING_HOST);
    const isRestApi = req.url.includes('/wp-json/');

    if (isStaging && !isRestApi) {
      const authReq = req.clone({
        setHeaders: { Authorization: `Basic ${STAGING_TOKEN}` }
      });
      return next.handle(authReq);
    }

    return next.handle(req);
  }
}
